import { horizontalRuleElementType } from "./HorizontalRuleElement.js";
const horizontalRuleToolbarButton = {
  elementType: horizontalRuleElementType,
  label: "Horizontal line",
  title: "Horizontal line",
  contemberIcon: "horizontalRule"
};
export {
  horizontalRuleToolbarButton
};
//# sourceMappingURL=horizontalRuleToolbarButton.js.map
